import React, {Component} from "react";
import styles from "./services.module.scss";
import appweb from '../HomeSlider/img/blanccambouis-web.png';
import portail from '../HomeSlider/img/ccilyon-web.png';
import ecommerce from '../HomeSlider/img/emmaus-web.jpg';
import site from '../HomeSlider/img/handiscover-web.jpg';
import iot from '../HomeSlider/img/ipaje-web.jpg';
import myooh from "../HomeSlider/img/digital-signage.jpg";
import scoreit from "../HomeSlider/img/scoreit-network.png";
import michelin from "./img/ps4.png";
import labco from "./img/labco.png";
import ades from "./img/ades.jpg";
import integral from "./img/integral-shop.jpg";

class Realisations extends Component {
    discover(data, title) {
        if(data != "") {
            return  <div className="col-md-12 p-0 d-flex justify-content-md-start justify-content-center">
                    <a  href={data} target="_blank" title={'En savoir plus sur  les '+title} rel="noopenerCannot read property 'frontmatter' of null" className="btn btn-primary">Découvrir</a>
                </div>;
        }
    }
    render() {
        let services = [
            {
                title: 'Integral System',
                subtitle: 'Un site E-Commerce B2B intégré et haute performance',
                image: integral,
                description: ["Développement à l'aide de Sylius d'un site E-Commerce haute performance pour Integral System spécialisé dans la fourniture de matériel informatique industriel comme les module ADAM, modules d'acquisition de données, affichages, écrans et pc industriels"],
                url: 'https://www.integral-system.fr/shop/'
            },
            {
                title: 'ADeS sécurité',
                subtitle: 'Un site E-Commerce B2B intégré à Wavesoft',
                image: ades,
                description: ["Création d'un site E-Commerce haute performance pour la société ADeS Sécurité spécialisé dans le domaine de la sécurité, incendie, intrusion, vidéo surveillance, contrôle d’accès, communication hospitalière, sonorisation ou interphonie. Réalisé avec Sylius & Symfony."],
                url: 'https://www.ades-securite.com/'
            },
            {
                title: 'Synlab Labco',
                subtitle: 'Portail et application mobile pour la gestion des analyses',
                image: labco,
                description: ["Réalisation d'un portail intranet et d'une application mobile dédiée à la gestion et au suivi des prélèvements des patients par les infirmières et les laboratoires d'analyse. Cette application centralise les prélèvements de plus de 5 millions de patients à travers l'Europe."],
                url: ''
            },
            {
                title: 'Michelin',
                subtitle: 'E-Commerce éphémère',
                image: michelin,
                description: ["Intégration du site de vente en ligne éphémère des pneus Michelin Pilot Sport 4. Réalisation d'une interface simple, graphique et intuitive pour améliorer la conversion et optimiser l'expérience de vente."],
                url: ''
            },
            {
                title: 'Myooh',
                subtitle: 'Player et portail pour affichage dynamique',
                image: myooh,
                description: ["Réalisation d'un portail Cloud et d'un player spécialisé pour l'affichage dynamique. Affichage entièrement Web, autonome et compatible offline spécialisé pour les métiers de l'immobilier."],
                url: ''
            },
            {
                title: 'Score It',
                subtitle: 'Réseau social pour compositeurs de musique',
                image: scoreit,
                description: ["Réalisation d'un réseau social orienté grand public et professionnels pour les compositeurs de musique. Les utilisateurs peuvent partager sous forme multimédia l'ensemble de leurs actualités musicales."],
                url: 'http://www.scoreit.org/'
            },
            {
                title: 'Blanc Cambouis',
                subtitle: 'Un site E-Commerce sur-mesure',
                image: appweb,
                description: ["Réalisation du ",<a href="/e-commerce" title="Site E-Commerce">site E-Commerce</a>," de la marque du designer de meuble vintage Blanc Cambouis. Vous pouvez entièrement choisir les options de votre meuble et les visualiser instantannément sur votre PC, Tablette ou Smartphone en 3D."],
                url: 'https://www.blanccambouis.fr'
            },
            {
                title: 'CCI Métropole Lyon',
                subtitle: 'Portail Web métier',
                image: portail,
                description: ["Intégration de l'ensemble du ",<a href="/portail-web-collaboratif" title="Réalisation de portail web">portail Web métier</a>," de la CCI de Lyon métropole aux couleurs de la nouvelle charte graphique des CCI."],
                url: 'https://www.lyon-metropole.cci.fr'
            },
            {
                title: 'Emmaus International',
                subtitle: 'Serious Game & Portail Web',
                image: ecommerce,
                description: ["Le ",<a href="/application-web" title="Application web et serious game">serious game</a>," \"Dans les pas de l'abbé Pierre\" de l'association Emmaüs International vous propose à travers un parcours, de découvrir les différents combats de l'abbé Pierre. Votre choix d'un combat par thématique vous permettra de d'établir votre profil militant."],
                url: 'http://www.actemmaus.org'
            },
            {
                title: 'Handiscover',
                subtitle: 'Application Web',
                image: site,
                description: ["Le jeu Web Handiscover a été conçu afin de faire évoluer le regard sur le handicap de façon ludique et originale. A travers 3 niveaux, le joueur est amené à découvrir 12 innovations révolutionnant le quotidien des personnes en situation de handicap et ce, aux quatre coins du monde. Lorsqu’il découvre une innovation, il doit aussi répondre à 2 questions en lien avec le handicap abordé et cumuler un maximum de points."],
                url: ''
            },
            {
                title: 'Ipaje',
                subtitle: 'Simulation de gestion d\'entreprise',
                image: iot,
                description: ["Création, pour le compte de la société Ipaje, d'une ",<a href="/application-web" title="Une Application Web sous forme de serious Game">application web responsive</a>," de simulation de gestion d'entreprise qui simule la vie et les comptes d'entreprises, en compétition de marché, destinée à la formation pour les salariés ou les étudiants."],
                url: ''
            }

        ];
        let servicesHmtlList = (
            <div>
                {services.map((service,index) =>
                    <section className={styles.serviceSection}>
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-12">
                                    <div className={`row row-bottom-padded-md row-top-padded-md ${styles.serviceContent} ${(index%2?'flex-row-reverse':'flex-row')}`}>
                                        <div className='col-md-7 align-self-stretch d-flex text-center'>
                                        <img src={service.image} alt={service.title} className={`text-sm-center img-fluid align-self-center`}/>
                                        </div>
                                        <div className="col-md-5 align-self-stretch d-flex">
                                            <div className="align-self-center">
                                                <h2 className="text-center text-md-left p-0 col-12 mb-2">{service.title}</h2>
                                                <h3 className="text-center text-md-left p-0 col-12">{service.subtitle}</h3>
                                                <p className="text-justify">
                                                {service.description}
                                                </p>
                                                { this.discover(service.url, service.title) }
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </section>
                )}
            </div>

        );

        return (
            <div className="serviceList">
                {servicesHmtlList}
            </div>
        );
    }
}

export default Realisations;



// WEBPACK FOOTER //
// ./src/components/Page/Realisation.jsx